import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export interface SpinnerProps {
  size?: SpinnerSize
  // Color / extra utility classes for the icon (e.g. 'text-primary').
  className?: string
  // Accessible name; defaults to the shared common.labels.refreshing string.
  'aria-label'?: string
}

// EP-95 T3 — the one shared spinner. Replaces 25 hand-rolled
// `<Loader2 className="animate-spin …" />` sites so size + a11y are uniform.
const SIZE: Record<SpinnerSize, string> = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
  xl: 'w-12 h-12',
}

export function Spinner({ size = 'md', className = '', 'aria-label': ariaLabel }: SpinnerProps) {
  const { t } = useTranslation('common')
  return (
    <Loader2
      role="status"
      aria-label={ariaLabel ?? t('labels.refreshing')}
      className={`animate-spin ${SIZE[size]} ${className}`.trim()}
    />
  )
}
